import { Injectable } from '@angular/core';

@Injectable()
export class StateService {
  public section: string;
  public svgready: boolean;

  public menubardata: MenuBar = new MenuBar();

  public navbarXL = false;
  public headline: string;
  public reportTitle: string;
  public subHeadlines: string[];

  public buttons_center: Button[] = [];
  public buttons_right: Button[] = [];

  constructor() {}

  changeSection(section: string) {
    if (this.section !== section) {
      this.section = section;
      this.resetMenu();
      this.resetHeadline();
    }
  }

  resetHeadline() {
    this.headline = 'Pathfinder Report';
    this.subHeadlines = [];
  }

  setHeadline(reportTitle: string, subHeadlines: string[] = []) {
    if (this.section === 'report') {
      this.reportTitle = reportTitle;
      this.subHeadlines = subHeadlines;
    } else {
      this.resetHeadline();
    }
  }

  resetMenu() {
    this.menubardata = new MenuBar();
    this.buttons_center = [];
    this.buttons_right = [];
  }

  addButton(btn: { id; label; icon?; classes?; onClick? }, position: string) {
    btn = new Button(btn);

    let dest: Button[];

    if (position === 'center') {
      dest = this.buttons_center;
    }
    if (position === 'right') {
      dest = this.buttons_right;
    }

    // look for same id
    for (const button of dest) {
      if (btn.id === button.id) {
        // if exists, return
        return;
      }
    }
    dest.push(btn);
  }

  removeButton(id: string, position: string) {
    let dest: Button[];

    if (position === 'center') {
      dest = this.buttons_center;
    }
    if (position === 'right') {
      dest = this.buttons_right;
    }

    // look for same id
    for (let b = 0; b < dest.length; b++) {
      const button = dest[b];
      if (id === button.id) {
        // if exists, return
        dest.splice(b, 1);
      }
    }
  }

  getButton(id: string, position: string) {
    let dest: Button[];

    if (position === 'center') {
      dest = this.buttons_center;
    }
    if (position === 'right') {
      dest = this.buttons_right;
    }

    // look for same id
    for (let b = 0; b < dest.length; b++) {
      const button = dest[b];
      if (id === button.id) {
        // if exists, return
        return dest[b];
      }
    }
  }
}

class MenuBar {
  buttons: any = [];
  data: any = null;
  sub_buttons: any = {};
  buttonsclick: Function = function() {
    return;
  };
  sub_buttonsclick: Function = function() {
    return;
  };
}

class Button {
  id: string;
  label: string;
  icon?: string;
  classes?: string;
  onClick?: Function = () => {
    return;
  };

  constructor(obj?) {
    if (obj) {
      for (const p of Object.keys(obj)) {
        this[p] = obj[p];
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/state.service.ts